<template>

<div class="group" v-bind:class="{'is-expanded': is.expanded}">
	
	<div class="group-title" v-on:click="onExpandClick">

		<i v-if="icon" class="group-icon fa" v-bind:class="{[iconClass]: icon}"></i>

		{{ title }} 

		<div v-if="count" class="group-title-count">{{ count }}</div>

		<div v-if="label" class="group-title-label" :class="{'has-count': count}">{{ label }}</div>

		<i class="group-chevron fa" v-bind:class="{'fa-chevron-down': is.expanded, 'fa-chevron-right': !is.expanded}"></i>

	</div>

	<div class="group-inputs">

		<slot></slot>

	</div>

</div>

</template>

<script>

export default {

	props: ['title', 'icon', 'count', 'label'],

	data: function() {

		return {

			is: {
				expanded: false
			}

		}

	},

	computed: {

		iconClass: function() {

			return 'fa-' + this.icon

		}

	},

	created: function() {

		this.$pubsub.$on('filter.advanced.expand', this.onFilterAdvancedExpand.bind(this))

	},

	beforeDestory: function() {

		this.$pubsub.$off('filter.advanced.expand', this.onFilterAdvancedExpand.bind(this))

	},

	methods: {

		onFilterAdvancedExpand: function(id) {

			if (id !== this._uid) this.is.expanded = false

		},

		onExpandClick: function() {

			this.is.expanded = !this.is.expanded

			if (this.is.expanded) {

				this.$pubsub.$emit('filter.advanced.expand', this._uid)

			}

		}

	}

}

</script>

<style scoped>

.group {
	flex-shrink: 0;
	width: 100%;
}

.group:last-child {
	border-bottom: 0px;
}

.group.is-expanded {
	padding-bottom: 10px;
    background-color: rgba(255, 255, 255, 0.15);
}

.group-title {
	font-size: 14px;
	height: 40px;
	line-height: 40px;
	font-weight: 400;
	color: #fff;
	padding: 0px 10px;
	user-select: none;
	cursor: pointer;
}

.group.is-expanded .group-title {
	font-weight: 500;
}

.group-title-count,
.group-title-label {
    background-color: #ffc563;
    border-radius: 4px;
    color: #333;
    position: absolute;
    right: 41px;
    top: 50%;
    margin-top: -10px;
    height: 20px;
    font-weight: 500;
    min-width: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    padding: 0px 5px;
}

.group-title-label {
	background-color: #133445;
}

.group-title-label.has-count {
	right: 71px;
}

.is-desktop .group-title:hover {
    background-color: rgba(255, 255, 255, 0.15);
}

.group.is-expanded .group-title {
	margin-bottom: 5px;
}

.group-icon {
	margin-right: 4px;
	width: 24px;
}

.group-chevron {
	position: absolute;
	right: 20px;
	top: 0px;
	line-height: 40px;
	font-size: 12px;
}

@media only screen and (max-width: 767px) {

	.group-chevron {
		right: 20px;
	}

}

.group-inputs {
	padding: 0px 10px;
	display: none;
	width: 100%;
}

@media only screen and (max-width: 767px) {

	.group-inputs {
		padding: 0px 10px;
	}

}

.group.is-expanded .group-inputs {
	display: block;
}

.group-inputs > div:last-child {
	margin-bottom: 0px;
}

.group-inputs > p {
	font-size: 12px;
	font-weight: 400;
	color: #fff;
	line-height: 16px;
	margin-bottom: 15px;	
}

</style>
